// extracted by mini-css-extract-plugin
export default {"stack":"MhvR4gtNCJTmkUAfzK0k","overview":"szpGgfNSCr110wiSMUQe"};